module.exports = __webpack_public_path__ + "img/20191204172839360截图20191204164603392.7531fe10.jpg";